import React, { useState, useEffect } from "react";
import axios from "axios";
import "./addcatagory.css";

const Addcatagory = () => {
  console.log("All env vars:", process.env);

  const [formData, setFormData] = useState({
    category: "",
    subcategory: "",
    // services: "",
  });

  const [categories, setCategories] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({
    category: "",
    subcategory: "",
    // services: "",
  });
  const [message, setMessage] = useState("");
  const [error, setError] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL;
  
  useEffect(() => {
    fetchCategories();
  }, []);
  
  const fetchCategories = async () => {
    try {
      const res = await axios.get(`${API_URL}/categories`);
      console.log('res', res)
      setCategories(res.data);

    } catch (err) {
      console.error("Error fetching categories:", err);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleEditChange = (e) => {
    setEditData({ ...editData, [e.target.name]: e.target.value });
  };

  const handleEdit = (cat) => {
    setEditId(cat._id);
    setEditData({
      category: cat.category,
      subcategory: Array.isArray(cat.subcategory)
        ? cat.subcategory.join(", ")
        : cat.subcategory || "",
      // services: Array.isArray(cat.services)
      //   ? cat.services.join(", ")
      //   : cat.services || "",
    });
  };

  const handleCancel = () => {
    setEditId(null);
    setEditData({ category: "",
       subcategory: "",
        // services: ""
       });
  };

  const handleUpdate = async (id) => {
    try {
      const subcategoryArray = editData.subcategory
        .split(",")
        .map((item) => item.trim())
        .filter((item) => item !== "");

      // const servicesArray = editData.services
      //   .split(",")
      //   .map((item) => item.trim())
      //   .filter((item) => item !== "");

      const res = await axios.put(`${API_URL}/categories/${id}`, {
        category: editData.category,
        subcategory: subcategoryArray,
        // services: servicesArray,
      });

      setCategories((prev) =>
        prev.map((cat) => (cat._id === id ? res.data.data : cat))
      );

      setEditId(null);
      setMessage("Category updated successfully!");
      setError(false);
    } catch (err) {
      setMessage(
        "Error updating category: " +
          (err.response?.data?.error || err.message)
      );
      setError(true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const subcategoryArray = formData.subcategory
        .split(",")
        .map((item) => item.trim())
        .filter((item) => item !== "");

      // const servicesArray = formData.services
      //   .split(",")
      //   .map((item) => item.trim())
      //   .filter((item) => item !== "");

      await axios.post(`${API_URL}/categories`, {
        category: formData.category,
        subcategory: subcategoryArray,
        // services: servicesArray,
      });

      setMessage("Category added successfully!");
      setError(false);
      setFormData({
         category: "",
          subcategory: "",
          //  services: ""
           });
      fetchCategories();
    } catch (err) {
      setMessage(
        "Error adding category: " +
          (err.response?.data?.error || err.message)
      );
      setError(true);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this category?")) {
      return;
    }
    try {
      await axios.delete(`${API_URL}/categories/${id}`);
      setCategories((prev) => prev.filter((cat) => cat._id !== id));
      setMessage("Category deleted successfully!");
      setError(false);
    } catch (err) {
      setMessage(
        "Error deleting category: " +
          (err.response?.data?.error || err.message)
      );
      setError(true);
    }
  };

  return (
    <div className="category-form-container">
      <h2>Add New Category</h2>

      {message && (
        <p className={`category-form-message ${error ? "error" : "success"}`}>
          {message}
        </p>
      )}

      {/* Add category form */}
      <form onSubmit={handleSubmit} className="category-form">
        <input
          type="text"
          name="category"
          placeholder="Category"
          value={formData.category}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="subcategory"
          placeholder="Subcategory (comma-separated)"
          value={formData.subcategory}
          onChange={handleChange}
          required
        />
        {/* <input
          type="text"
          name="services"
          placeholder="Services (comma-separated)"
          value={formData.services}
          onChange={handleChange}
        /> */}
        <button type="submit">Add Category</button>
      </form>

      {/* Category table */}
      <div className="category-table-container">
        <h2>Existing Categories</h2>
        {categories.length === 0 ? (
          <p>No categories found.</p>
        ) : (
          <table className="category-table">
            <thead>
              <tr>
                <th>Category</th>
                <th>Subcategories</th>
                {/* <th>Services</th> */}
                <th>Created Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((cat) => (
                <tr key={cat._id}>
                  {editId === cat._id ? (
                    <>
                      <td>
                        <input
                          type="text"
                          name="category"
                          value={editData.category}
                          onChange={handleEditChange}
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          name="subcategory"
                          value={editData.subcategory}
                          onChange={handleEditChange}
                          placeholder="Comma-separated"
                        />
                      </td>
                      {/* <td>
                        <input
                          type="text"
                          name="services"
                          value={editData.services}
                          onChange={handleEditChange}
                          placeholder="Comma-separated"
                        />
                      </td> */}
                      <td>{new Date(cat.createdAt).toLocaleDateString()}</td>
                      <td>
                        <button onClick={() => handleUpdate(cat._id)}>Save</button>
                        <button onClick={handleCancel}>Cancel</button>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>{cat.category}</td>
                      <td>
                        {Array.isArray(cat.subcategory)
                          ? cat.subcategory.join(", ")
                          : cat.subcategory}
                      </td>
                      {/* <td>
                        {Array.isArray(cat.services)
                          ? cat.services.join(", ")
                          : cat.services}
                      </td> */}
                      <td>{new Date(cat.createdAt).toLocaleDateString()}</td>
                      <td>
                        <button onClick={() => handleEdit(cat)}>Edit</button>
                        <button
                          className="delete-btn"
                          onClick={() => handleDelete(cat._id)}
                        >
                          Delete
                        </button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default Addcatagory;
